/* Timbrica — /pulse-meter. Пульс по камере телефона (и вручную на десктопе).
 *
 * ПОЧЕМУ ЭТОТ ТУЛ
 * ---------------
 * «измерить пульс» — 11 738 показов/мес, и это САМАЯ ПУСТАЯ выдача из тридцати
 * четырёх, что я смотрел: справка Google Fit, две карточки приложений, Welltory,
 * блоги Дзена. Веб-инструмента нет вообще — при том что телефон умеет это без
 * установки.
 *
 * ГЛАВНОЕ РЕШЕНИЕ — ПРАВО МОЛЧАТЬ.
 * Приложения показывают число всегда: палец съехал, свет мигнул, руки трясутся —
 * всё равно «72». У нас число появляется только когда сигнал действительно
 * периодичен (порог в pulse-core.js, замерен на 3 888 настоящих записях с
 * эталоном по ЭКГ), иначе на экране написано, ЧТО именно не так и что
 * поправить. ⚠️ Право молчать — не право молчать ВСЕГДА: до 28.10 тул
 * отказывал в 4 случаях из 5 из-за перевёрнутого фильтра (отзыв #2034).
 *
 * ВТОРОЕ РЕШЕНИЕ (переделка 2026-08-14) — ВЕСТИ, А НЕ СУДИТЬ ЗАДНИМ ЧИСЛОМ.
 * Первая версия молча писала 25 секунд ЧЕГО УГОДНО и только в конце говорила
 * «пальца не было». Реальный человек так и попался: ждал полминуты и получил
 * пустоту. Теперь отсчёт НЕ НАЧИНАЕТСЯ, пока детектор пальца (по кадрам, живьём)
 * не увидит палец; съехал в процессе — отсчёт честно начинается заново, и об
 * этом сказано сразу, а не через 25 секунд.
 *
 * ⚠️ Это не медицинский прибор. Так и написано на странице рядом с числом,
 * а не мелким шрифтом внизу.
 */
(function () {
  'use strict';

  var C = window.PULSE_CFG || {};
  var T = C.t || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };
  var stage = function (n) { try { window.__stage && window.__stage(n); } catch (e) {} };
  // Незрячему пользователю кривая и полоска не говорят ничего — результат и
  // причину отказа он должен УСЛЫШАТЬ.
  var announce = function (m) { try { window.__announce && window.__announce(m); } catch (e) {} };

  var PC = window.PulseCore;
  if (!PC) { return; }

  var MEASURE_MS = 25000;      // 25 с: короче — автокорреляция шумит на медленном пульсе
  var ROLL = 45;               // ~1.5 с при 30 fps — окно живого детектора пальца
  var HIST_MAX = 50;

  // idle → starting → finger_wait ⇄ measuring → done | failed
  var st = {
    phase: 'idle',
    stream: null, video: null, canvas: null, ctx: null, track: null, torchOn: false,
    samples: [], times: [], raf: 0, measureStart: 0, waitStart: 0, prelimAt: 0,
    roll: [], lostSince: 0, darkRecent: 0, why: [], torchCap: false,
    frames: 0, fingerFrames: 0,
    taps: [], lastTapBpm: null,
    liveBpm: null,
    history: []
  };

  function setText(id, v) { var el = $(id); if (el) el.textContent = v; }
  function show(id, on) { var el = $(id); if (el) el.hidden = !on; }
  function fmt(x, d) {
    try { return Number(x).toLocaleString(C.locale, { minimumFractionDigits: d || 0, maximumFractionDigits: d || 0 }); }
    catch (e) { return Number(x).toFixed(d || 0); }
  }

  // ── Переключение экранов стадии ────────────────────────────────────────────
  // Один контейнер, четыре экрана: страница не прыгает, состояние всегда одно.

  function setPhase(p) {
    st.phase = p;
    show('plIdle', p === 'idle');
    show('plLiveWrap', p === 'starting' || p === 'finger_wait' || p === 'measuring');
    show('plDone', p === 'done');
    show('plFail', p === 'failed');
    show('plStart', p === 'idle');
    show('plStop', p === 'starting' || p === 'finger_wait' || p === 'measuring');
    show('plTips', false);
    var card = $('plStage');
    if (card) card.setAttribute('data-phase', p);
  }

  // ── Камера ──────────────────────────────────────────────────────────────────

  function start() {
    if (st.phase !== 'idle' && st.phase !== 'done' && st.phase !== 'failed') return;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      failNow('no_camera'); return;
    }
    setPhase('starting');
    setText('plState', tr('st_starting'));
    resetLive();
    st.torchCap = false;
    navigator.mediaDevices.getUserMedia({
      video: { facingMode: { ideal: 'environment' }, width: { ideal: 320 }, height: { ideal: 240 }, frameRate: { ideal: 30 } },
      audio: false
    }).then(function (stream) {
      st.stream = stream;
      st.track = stream.getVideoTracks()[0];
      // Фонарик — половина успеха: без подсветки палец даёт почти нулевой
      // сигнал. Поддержки может не быть (iOS), тогда просто просим свет.
      try {
        var caps = st.track.getCapabilities ? st.track.getCapabilities() : {};
        if (caps && caps.torch) {
          st.torchCap = true;
          st.track.applyConstraints({ advanced: [{ torch: true }] })
            .then(function () { st.torchOn = true; })
            .catch(function () {});
        }
      } catch (e) {}

      var v = $('plVideo');
      v.srcObject = stream;
      v.play().catch(function () {});
      st.video = v;
      st.canvas = document.createElement('canvas');
      st.canvas.width = 64; st.canvas.height = 48;
      st.ctx = st.canvas.getContext('2d', { willReadFrequently: true });

      enterFingerWait(true);
      loop();
      ae('feature_use', { slug: 'pulse-meter', feature: 'camera_start' });
    }).catch(function (err) {
      setPhase('idle');
      setText('plState', tr(err && err.name === 'NotAllowedError' ? 'st_denied' : 'st_no_camera'));
      ae('tool_diagnostic', { slug: 'pulse-meter', issue: 'camera_' + (err && err.name || 'fail') });
    });
  }

  function stopCamera() {
    cancelAnimationFrame(st.raf);
    if (st.track && st.torchOn) { try { st.track.applyConstraints({ advanced: [{ torch: false }] }); } catch (e) {} }
    if (st.stream) st.stream.getTracks().forEach(function (t) { t.stop(); });
    st.stream = null; st.track = null; st.torchOn = false;
  }

  function resetLive() {
    st.samples = []; st.times = []; st.roll = []; st.why = []; st.prelimAt = 0;
    st.frames = 0; st.fingerFrames = 0; st.lostSince = 0; st.liveBpm = null;
    setBar(0);
    setText('plCountdown', '');
    show('plLiveBpm', false);
    heartRate(null);
  }

  function enterFingerWait(first) {
    st.phase = 'finger_wait';
    st.waitStart = performance.now();
    st.samples = []; st.times = [];
    st.frames = 0; st.fingerFrames = 0; st.lostSince = 0; st.liveBpm = null;
    setPhase('finger_wait');
    setText('plState', tr('st_finger_wait'));
    show('plLiveBpm', false);
    setBar(0);
    setText('plCountdown', '');
    heartRate(null);
    if (!first) setText('plState', tr('st_finger_lost'));
  }

  function enterMeasuring() {
    st.phase = 'measuring';
    setPhase('measuring');
    st.measureStart = performance.now();
    st.samples = []; st.times = [];
    st.frames = 0; st.fingerFrames = 0; st.lostSince = 0;
    setText('plState', tr('st_measuring'));
    stage('measuring');
  }

  // ── Главный цикл ────────────────────────────────────────────────────────────

  function loop() {
    if (st.phase !== 'finger_wait' && st.phase !== 'measuring') return;
    st.raf = requestAnimationFrame(loop);
    var v = st.video;
    if (!v || v.readyState < 2) return;

    if (!window.__drawCameraFrame(st.ctx, v, 0, 0, 64, 48)) return;   // no frame this tick
    // Берём центр кадра: края закрыты корпусом и вносят только шум.
    var d = st.ctx.getImageData(20, 14, 24, 20).data;
    var sum = 0, sumG = 0, cnt = 0;
    for (var i = 0; i < d.length; i += 4) { sum += d[i]; sumG += d[i + 1]; cnt++; }
    var red = sum / cnt, green = sumG / cnt;
    var spread = 0;
    for (var j = 0; j < d.length; j += 4) { var dv = d[j] - red; spread += dv * dv; }
    spread = Math.sqrt(spread / cnt) / (red || 1);

    var f = PC.fingerFrame(red, green, spread);
    st.roll.push(f.finger ? 1 : 0);
    if (st.roll.length > ROLL) st.roll.shift();
    // Что видел детектор — для телеметрии рестарта: «палец сместился» бывает
    // в 35–40 % сессий, а какой признак пальца отказал, не знал никто.
    st.why.push([red, green, spread]);
    if (st.why.length > ROLL) st.why.shift();
    st.darkRecent = f.dark ? Math.min(60, st.darkRecent + 1) : Math.max(0, st.darkRecent - 2);

    var share = rollShare(st.roll.length >= 20 ? 20 : st.roll.length);
    updateChips(share >= 0.7, st.darkRecent > 20);

    var now = performance.now();

    if (st.phase === 'finger_wait') {
      // Волна рисуется и в ожидании — тусклее: видно, что камера живая.
      st.samples.push(red); st.times.push(now);
      if (st.samples.length > 240) { st.samples.shift(); st.times.shift(); }
      drawWave(true);
      // Старт отсчёта — когда палец стабильно в кадре ~0.7 с.
      if (st.roll.length >= 20 && rollShare(20) >= 0.8) { enterMeasuring(); return; }
      // Долго не выходит — показываем подсказки, а не молчим.
      if (now - st.waitStart > 10000) show('plTips', true);
      return;
    }

    // measuring
    st.frames++;
    if (f.finger) st.fingerFrames++;
    st.samples.push(red);
    st.times.push(now);

    // Палец пропал: короткий смаз прощаем, потерю >1.5 с — честный рестарт.
    if (rollShare(ROLL) < 0.5) {
      if (!st.lostSince) st.lostSince = now;
      else if (now - st.lostSince > 1500) {
        ae('tool_diagnostic', fingerReport({ slug: 'pulse-meter', issue: 'finger_lost_restart', at_s: Math.round(elapsedNow(now) / 1000) }));
        enterFingerWait(false);
        return;
      }
    } else st.lostSince = 0;

    var elapsed = now - st.measureStart;
    setBar(Math.min(100, elapsed / MEASURE_MS * 100));
    setText('plCountdown', Math.max(0, Math.ceil((MEASURE_MS - elapsed) / 1000)) + ' ' + tr('sec'));
    drawWave(false);

    // Промежуточная оценка с 8-й секунды — человеку важно видеть процесс.
    // Раз в секунду, а не на каждом 15-м кадре (~4 раза в секунду): спектр по
    // 20–30 с ряда — 1–2 мс на десктопе, вдвое дороже прежней автокорреляции,
    // а предварительному числу чаще меняться незачем.
    if (elapsed > 8000 && now - st.prelimAt >= 1000) { st.prelimAt = now; prelim(); }
    if (elapsed >= MEASURE_MS) finalAnalyse();
  }

  function elapsedNow(now) { return st.measureStart ? now - st.measureStart : 0; }

  /**
   * Что видел детектор пальца за последние ~1.5 с: сколько кадров отвергнуто
   * каждым признаком и средние уровни. По этим числам решается, виноват ли
   * человек (палец ушёл) или порог (iPhone без фонарика темнее, чем думали).
   */
  function fingerReport(p) {
    var w = st.why, n = w.length, dark = 0, color = 0, uneven = 0, rs = [], gs = [], ss = [];
    for (var i = 0; i < n; i++) {
      var r = w[i][0], g = w[i][1], s = w[i][2];
      if (r < 26) dark++;
      else if (r < g * 1.3) color++;
      else if (s > 0.6) uneven++;
      rs.push(r); gs.push(g); ss.push(s);
    }
    var med = function (a) { a.sort(function (x, y) { return x - y; }); return a.length ? a[a.length >> 1] : 0; };
    p.n = n; p.dark = dark; p.color = color; p.uneven = uneven;
    p.red = Math.round(med(rs)); p.green = Math.round(med(gs)); p.spread = Math.round(med(ss) * 100) / 100;
    p.torch = torchState();
    return p;
  }

  /** 1 — фонарик горит, 0 — есть, но не включился, -1 — его нет (iOS). */
  function torchState() { return st.torchOn ? 1 : (st.torchCap ? 0 : -1); }

  function rollShare(n) {
    var len = st.roll.length; if (!len) return 0;
    n = Math.min(n, len);
    var s = 0;
    for (var i = len - n; i < len; i++) s += st.roll[i];
    return s / n;
  }

  function updateChips(fingerOk, dark) {
    var fc = $('plChipFinger'), lc = $('plChipLight');
    if (fc) {
      fc.classList.toggle('ok', fingerOk);
      var span = fc.querySelector('span');
      if (span) span.textContent = fingerOk ? tr('chip_ok') : tr('chip_searching');
    }
    if (lc) {
      lc.hidden = !dark;
    }
  }

  /**
   * Лента записи в результате: доказательство того, ЧТО именно измерено.
   * Число без кривой человеку нечем проверить; кривая показывает, ровный был
   * ритм или рваный, и это ровно тот вопрос, ради которого приходят.
   */
  function drawTrace() {
    var cv = $('plTrace');
    if (!cv) return;
    var take = st.samples.slice(-Math.round(fpsNow() * 8));   // последние ~8 с
    if (take.length < 8) return;
    var w = cv.clientWidth || 320, h = 70, dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = w * dpr; cv.height = h * dpr; cv.style.height = h + 'px';
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);
    var lo = Math.min.apply(null, take), hi = Math.max.apply(null, take);
    var span = Math.max(0.4, hi - lo);
    g.beginPath();
    take.forEach(function (v, i) {
      var x = (i / (take.length - 1)) * w;
      var y = h - 6 - ((v - lo) / span) * (h - 12);
      i ? g.lineTo(x, y) : g.moveTo(x, y);
    });
    g.strokeStyle = '#ff6b81'; g.lineWidth = 1.6; g.lineJoin = 'round'; g.stroke();
  }

  /** Живая волна — самопроверка: видно, есть ли сигнал, ещё до результата. */
  function drawWave(dim) {
    var cv = $('plWave');
    if (!cv) return;
    var w = cv.clientWidth || 320, h = 96, dpr = Math.min(window.devicePixelRatio || 1, 2);
    if (cv.width !== w * dpr) { cv.width = w * dpr; cv.height = h * dpr; cv.style.height = h + 'px'; }
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);

    // Сетка монитора — три тихих линии, чтобы волне было обо что мериться.
    g.strokeStyle = 'rgba(255,107,129,.08)'; g.lineWidth = 1;
    for (var yy = 1; yy <= 3; yy++) {
      g.beginPath(); g.moveTo(0, h * yy / 4); g.lineTo(w, h * yy / 4); g.stroke();
    }

    var take = st.samples.slice(-240);
    if (take.length < 4) return;
    var lo = Math.min.apply(null, take), hi = Math.max.apply(null, take);
    var span = Math.max(0.4, hi - lo);
    g.beginPath();
    take.forEach(function (v, i) {
      var x = (i / (take.length - 1)) * w;
      var y = h - 8 - ((v - lo) / span) * (h - 16);
      i ? g.lineTo(x, y) : g.moveTo(x, y);
    });
    g.strokeStyle = dim ? 'rgba(255,107,129,.35)' : '#ff6b81';
    g.lineWidth = 2;
    g.shadowColor = dim ? 'transparent' : 'rgba(255,107,129,.55)';
    g.shadowBlur = dim ? 0 : 6;
    g.stroke();
    g.shadowBlur = 0;
  }

  function fpsNow() {
    var n = st.times.length;
    if (n < 10) return 30;
    var span = (st.times[n - 1] - st.times[0]) / 1000;
    return span > 0 ? (n - 1) / span : 30;
  }

  /** Сердце бьётся с частотой ИЗМЕРЕННОГО пульса. null — тихое дыхание. */
  function heartRate(bpm) {
    var el = $('plHeart');
    if (!el) return;
    if (bpm) el.style.animationDuration = (60 / bpm).toFixed(2) + 's';
    else el.style.animationDuration = '';
    el.classList.toggle('beating', !!bpm);
  }

  function prelim() {
    // По МЕТКАМ ВРЕМЕНИ, а не по среднему fps: кадры приходят неравномерно
    // (страница подтормаживает, телефон греется), и допущение о равномерности
    // стоило 8 уд/мин ошибки на замере 14.08.
    // Порог строже итогового: на 8–15 с ложь выше (pulse-core.js, PRELIM_SNR).
    var r = PC.estimateTimed(st.samples, st.times, { prelim: true });
    if (r.ok) {
      st.liveBpm = r.bpm;
      show('plLiveBpm', true);
      setText('plLiveNum', fmt(r.bpm, 0));
      heartRate(r.bpm);
    }
  }

  function finalAnalyse() {
    var torch = torchState();    // ДО stopCamera: он гасит фонарик
    stopCamera();
    // Гейт «а палец ли это был» — теперь почти всегда пройден (живой детектор
    // не дал бы досчитать), но остаётся как последняя линия честности.
    var fingerShare = st.frames ? st.fingerFrames / st.frames : 0;
    if (fingerShare < 0.6) {
      failNow('no_finger');
      ae('tool_diagnostic', { slug: 'pulse-meter', issue: 'no_finger', share: Math.round(fingerShare * 100), frames: st.frames });
      return;
    }
    // По МЕТКАМ ВРЕМЕНИ, а не по среднему fps: кадры приходят неравномерно
    // (страница подтормаживает, телефон греется), и допущение о равномерности
    // стоило 8 уд/мин ошибки на замере 14.08.
    var r = PC.estimateTimed(st.samples, st.times);
    // SNR и частота кадров едут и в отказе, и в числе: без них «noisy» —
    // слово, по которому порог не пересмотреть (так было до 28.10).
    var why = { snr: r.snr != null ? Math.round(r.snr * 100) / 100 : null, fps: Math.round(r.fps || 0), gap: Math.round(r.gapMs || 0), torch: torch };
    if (!r.ok) {
      failNow(r.reason);
      ae('tool_diagnostic', Object.assign({ slug: 'pulse-meter', issue: 'estimate_' + r.reason }, why));
      return;
    }
    showResult(r, why);
  }

  /** Отказ — это ЭКРАН с причиной и подсказками, а не пустое место. */
  function failNow(reason) {
    stopCamera();
    setPhase('failed');
    var key = 'st_fail_' + reason;
    var msg = tr(key);
    if (msg === key) msg = tr(reason === 'no_camera' ? 'st_no_camera' : 'st_fail_noisy');
    setText('plFailMsg', msg);
    setText('plState', '');
    announce(msg);
  }

  function showResult(r, why) {
    setPhase('done');
    drawTrace();                 // ПОСЛЕ setPhase: у скрытого canvas clientWidth = 0
    var bpm = Math.round(r.bpm);
    setText('plBpm', fmt(bpm, 0));
    setText('plZone', zoneLabel(bpm));
    heartRate(bpm);
    var doneHeart = $('plDoneHeart');
    if (doneHeart) {
      doneHeart.style.animationDuration = (60 / bpm).toFixed(2) + 's';
      doneHeart.classList.add('beating');
    }

    // Маркер на шкале 40–180: где вы на ленте от редкого до учащённого.
    var marker = $('plScaleMark');
    if (marker) {
      var pos = Math.max(0, Math.min(1, (bpm - 40) / 140));
      marker.style.insetInlineStart = (pos * 100).toFixed(1) + '%';
    }

    var q = $('plQuality');
    if (q) q.style.width = Math.round(r.quality * 100) + '%';
    setText('plQualityText', r.quality >= 0.6 ? tr('q_good') : tr('q_fair'));
    show('plLowQuality', r.quality < 0.5);

    addHistory({ t: Date.now(), bpm: bpm, m: 'cam' });
    setText('plState', '');
    announce(fmt(bpm, 0) + ' ' + tr('bpm') + '. ' + zoneLabel(bpm));
    stage('complete');
    ae('tool_complete', Object.assign({ slug: 'pulse-meter', bpm: bpm, quality: +r.quality.toFixed(2) }, why || {}));
  }

  /** Словесная рамка вокруг числа. НЕ диагноз. */
  function zoneLabel(bpm) {
    if (bpm < 60) return tr('zone_low');
    if (bpm <= 100) return tr('zone_normal');
    return tr('zone_high');
  }

  function zoneClass(bpm) {
    if (bpm < 60) return 'low';
    if (bpm <= 100) return 'norm';
    return 'high';
  }

  function setBar(pct) {
    var bar = $('plProgress');
    if (bar) bar.style.width = pct.toFixed(1) + '%';
  }

  // ── История измерений ───────────────────────────────────────────────────────
  // Все большие пульсометры хранят историю — без неё число нельзя сравнить
  // с «а сколько было вчера». Живёт только в браузере (localStorage).

  function loadHistory() {
    try {
      if (window.__toolSettings) st.history = window.__toolSettings.load('pulse-meter', 'history', []) || [];
    } catch (e) { st.history = []; }
    if (!Array.isArray(st.history)) st.history = [];
    renderHistory();
  }

  function saveHistory() {
    try { window.__toolSettings && window.__toolSettings.save('pulse-meter', 'history', st.history); } catch (e) {}
  }

  function addHistory(entry) {
    st.history.unshift(entry);
    if (st.history.length > HIST_MAX) st.history.length = HIST_MAX;
    saveHistory();
    renderHistory();
    // «Мой прогресс» reads the history saved just above straight from the
    // browser (public/js/progress/local.js → pulse). Nothing is reported to
    // the server: a pulse reading is health data, and health results are not
    // kept there (Farid 2026-09-23; config/progress.php → pulse, `device`).
  }

  function renderHistory() {
    var card = $('plHistoryCard'), list = $('plHistory');
    if (!card || !list) return;
    if (!st.history.length) { card.hidden = true; return; }
    card.hidden = false;
    list.textContent = '';
    st.history.slice(0, 8).forEach(function (h) {
      var row = document.createElement('div');
      row.className = 'plm-hrow';
      var when = '';
      try {
        when = new Date(h.t).toLocaleString(C.locale, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
      } catch (e) { when = new Date(h.t).toLocaleString(); }
      var dot = document.createElement('i');
      dot.className = 'plm-dot ' + zoneClass(h.bpm);
      var num = document.createElement('b');
      num.textContent = fmt(h.bpm, 0);
      var meta = document.createElement('span');
      meta.className = 'plm-hmeta';
      meta.textContent = (h.m === 'tap' ? tr('history_tap') : tr('history_cam')) + ' · ' + when;
      row.appendChild(dot); row.appendChild(num); row.appendChild(meta);
      list.appendChild(row);
    });
    drawSpark();
  }

  /** Мини-график последних измерений: тренд виден без единого слова. */
  function drawSpark() {
    var cv = $('plSpark');
    if (!cv) return;
    var pts = st.history.slice(0, 20).reverse().map(function (h) { return h.bpm; });
    if (pts.length < 2) { cv.hidden = true; return; }
    cv.hidden = false;
    var w = cv.clientWidth || 260, h = 44, dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = w * dpr; cv.height = h * dpr; cv.style.height = h + 'px';
    var g = cv.getContext('2d');
    g.setTransform(dpr, 0, 0, dpr, 0, 0);
    g.clearRect(0, 0, w, h);
    var lo = Math.min.apply(null, pts) - 4, hi = Math.max.apply(null, pts) + 4;
    var span = Math.max(8, hi - lo);
    g.beginPath();
    pts.forEach(function (v, i) {
      var x = 4 + (i / (pts.length - 1)) * (w - 8);
      var y = h - 5 - ((v - lo) / span) * (h - 10);
      i ? g.lineTo(x, y) : g.moveTo(x, y);
    });
    g.strokeStyle = '#ff6b81'; g.lineWidth = 2; g.lineJoin = 'round'; g.stroke();
    pts.forEach(function (v, i) {
      var x = 4 + (i / (pts.length - 1)) * (w - 8);
      var y = h - 5 - ((v - lo) / span) * (h - 10);
      g.beginPath(); g.arc(x, y, 2, 0, Math.PI * 2);
      g.fillStyle = '#ff6b81'; g.fill();
    });
  }

  // ── Ручной подсчёт ──────────────────────────────────────────────────────────

  function tap() {
    var now = performance.now();
    // Забываем старое: если человек отвлёкся, интервал в минуту испортит всё.
    if (st.taps.length && now - st.taps[st.taps.length - 1] > 3000) st.taps = [];
    st.taps.push(now);
    setText('plTapCount', String(st.taps.length));
    var btn = $('plTapBtn');
    if (btn) { btn.classList.remove('thump'); void btn.offsetWidth; btn.classList.add('thump'); }
    var r = PC.fromTaps(st.taps);
    if (r.ok) {
      st.lastTapBpm = Math.round(r.bpm);
      setText('plTapBpm', fmt(r.bpm, 0));
      setText('plTapZone', zoneLabel(r.bpm));
      var spread = $('plTapSpread');
      // Большой разброс интервалов — это «сбились», а не аритмия. Так и пишем.
      if (spread) {
        var rel = r.spreadMs / (60000 / r.bpm);
        spread.hidden = rel < 0.12;
        spread.textContent = tr('taps_uneven');
      }
      show('plTapResult', true);
      show('plTapSave', true);
    } else {
      st.lastTapBpm = null;
      setText('plTapBpm', '—');
      show('plTapSave', false);
    }
  }

  function boot() {
    stage('load');
    var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
    on('plStart', start);
    on('plStop', function () { stopCamera(); setPhase('idle'); setText('plState', tr('st_idle')); });
    on('plAgain', start);
    on('plRetry', start);
    on('plTapBtn', tap);
    on('plTapReset', function () {
      st.taps = []; st.lastTapBpm = null;
      setText('plTapCount', '0'); setText('plTapBpm', '—');
      show('plTapResult', false); show('plTapSave', false);
    });
    on('plTapSave', function () {
      if (!st.lastTapBpm) return;
      addHistory({ t: Date.now(), bpm: st.lastTapBpm, m: 'tap' });
      show('plTapSave', false);
      try { window.__toast && window.__toast(tr('saved'), 'success'); } catch (e) {}
    });
    // Журнал измерений живёт только здесь — стереть его случайным кликом
    // человек не должен. Второе нажатие в течение 4 секунд подтверждает.
    var clearArmed = 0;
    on('plHistoryClear', function () {
      var btn = $('plHistoryClear');
      if (!clearArmed) {
        clearArmed = setTimeout(function () {
          clearArmed = 0;
          if (btn) btn.textContent = tr('history_clear');
        }, 4000);
        if (btn) btn.textContent = tr('history_clear_confirm');
        return;
      }
      clearTimeout(clearArmed); clearArmed = 0;
      if (btn) btn.textContent = tr('history_clear');
      st.history = [];
      saveHistory();
      renderHistory();
    });
    // Пробел — привычная клавиша для отбивания ритма.
    document.addEventListener('keydown', function (e) {
      if (e.code === 'Space' && document.activeElement && document.activeElement.id === 'plTapBtn') {
        e.preventDefault(); tap();
      }
    });

    // Десктоп: честно предупреждаем, что без вспышки сигнал слабее,
    // и что ручной подсчёт — равноправный путь, а не запасной выход.
    try {
      if (window.matchMedia && !window.matchMedia('(pointer: coarse)').matches) show('plDesktopNote', true);
    } catch (e) {}

    setPhase('idle');
    setText('plState', tr('st_idle'));
    loadHistory();
    stage('ready');
    window.addEventListener('pagehide', stopCamera);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
